var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEditIconDf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1716 1.99785L9.83827 3.33119H3.33333V12.6645H12.6667V6.15962L14 4.82629V13.3312C14 13.6994 13.7015 13.9979 13.3333 13.9979H2.66667C2.29848 13.9979 2 13.6994 2 13.3312V2.66452C2 2.29633 2.29848 1.99785 2.66667 1.99785H11.1716ZM13.6569 1.39819L14.5997 2.341L8.4714 8.46927L7.53027 8.47093L7.5286 7.52647L13.6569 1.39819Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditIconDf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EditIconDF.30d4293e.svg";
export { ForwardRef as ReactComponent };